/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GetCompanyToHireRequest = {
  properties: {
    cnpj: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
